/* ═══════════════════════════════════════════════════════════════════════
   Solve Labs — 15D

   Ported from the approved home15d prototype. Two things changed on the way
   into the theme, and only two:

   1. The cart is the real Shopify cart. Every line, price and total comes
      from /cart.js, so the drawer can never show something checkout would
      not honour.
   2. The day bar reads its hours from the JSON the section prints, instead
      of scraping the product rails. It therefore keeps working on a page
      that has no rails on it.

   Everything else — the drag, the mega panels, the marquee, the count-up,
   the clock — is the prototype's behaviour unchanged.

   Every block is guarded. A section the merchant removes must not take the
   rest of the page down with it.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.SolveTheme || {};
  var $ = function (id) { return document.getElementById(id); };
  var all = function (sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  };

  /* ── money ────────────────────────────────────────────────────────────
     Shopify hands us the shop's own format string; honouring it is what
     keeps a £ store from rendering $ in the drawer.                      */
  function formatMoney(cents) {
    /* Shops may carry markup in money_format — "<span>£{{amount}}</span>" is
       common. The layout strips it, and so do we: this function's output is
       written with textContent in several places, where a stray tag would
       print as characters instead of disappearing. */
    var fmt = (CFG.moneyFormat || '£{{amount}}').replace(/<[^>]*>/g, '');
    var value = (cents || 0) / 100;

    function withCommas(n, decimals) {
      var fixed = n.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(Math.round(value), 0);
        case 'amount_with_comma_separator':
          return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(Math.round(value), 0).replace(/,/g, ' ');
        case 'amount_with_space_separator':
          return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
        default: return withCommas(value, 2);
      }
    });
  }

  /* ── announce rotates ─────────────────────────────────────────────── */
  var slides = all('.announce .slide'), ai = 0;
  if (slides.length > 1) {
    setInterval(function () {
      slides[ai].classList.remove('on');
      ai = (ai + 1) % slides.length;
      slides[ai].classList.add('on');
    }, 4200);
  }

  /* ══ THE CART ═════════════════════════════════════════════════════════
     The drawer is a view onto /cart.js and nothing else.                 */
  var FREE = (CFG.freeShippingThreshold || 50) * 100;
  var drawer = $('drawer'), scrim = $('scrim');

  function openCart() {
    /* Rebuy's Smart Cart is the basket when it has loaded (layout/theme.liquid, window.SolveCart); this drawer is the fallback */
    if (window.SolveCart && window.SolveCart.open()) return;
    if (!drawer) return;
    drawer.classList.add('on');
    if (scrim) scrim.classList.add('on');
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('on');
    if (scrim) scrim.classList.remove('on');
  }
  if ($('openCart')) $('openCart').onclick = function () { openCart(); };
  if ($('closeCart')) $('closeCart').onclick = closeCart;
  if (scrim) scrim.addEventListener('click', closeCart);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function renderCart(cart) {
    if (!cart) return;
    var count = cart.item_count || 0, total = cart.total_price || 0;

    if ($('cartCount')) { $('cartCount').textContent = count; $('cartCount').classList.toggle('has', count > 0); }
    if ($('dtot')) $('dtot').textContent = formatMoney(total);

    var items = $('ditems');
    if (items) {
      items.innerHTML = count
        ? cart.items.map(function (c) {
            var img = c.image ? '<img src="' + c.image + '" alt="" width="52" height="52">' : '';
            return '<div class="di">' + img + '<div><h4>' + c.product_title + '</h4>' +
              '<div class="q">Qty ' + c.quantity + ' · ' + formatMoney(c.final_price) + ' each</div>' +
              '<a class="rm" href="#" data-rm="' + c.key + '">Remove</a></div>' +
              '<span>' + formatMoney(c.final_line_price) + '</span></div>';
          }).join('')
        : '<p class="demp">Nothing in here yet.</p>';
    }

    if ($('shipBar')) $('shipBar').style.width = Math.min(100, FREE ? total / FREE * 100 : 100) + '%';
    if ($('shipMsg')) {
      $('shipMsg').innerHTML = total >= FREE
        ? 'Free UK delivery unlocked <b>&#10003;</b>'
        : (total > 0
            ? 'You are <b>' + formatMoney(FREE - total) + '</b> away from free UK delivery'
            : 'Free UK delivery over <b>' + formatMoney(FREE) + '</b>');
    }
  }

  function refreshCart(open) {
    return fetch(CFG.cartUrl ? CFG.cartUrl + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; })
      .catch(function () {});
  }

  /* items: [{id: variantId, quantity: n}] */
  function addToCart(items) {
    var list = [].concat(items).filter(function (i) { return i && i.id; });
    if (!list.length) return Promise.resolve();
    return fetch(CFG.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: list })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
        return r.json();
      })
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        /* an add that silently fails is worse than one that says so */
        if (window.console) console.warn('[solve] add to cart failed:', err.message);
        alert(err.message || 'Sorry — that could not be added to the cart.');
      });
  }

  /* remove */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rm]');
    if (!a) return;
    e.preventDefault();
    fetch(CFG.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: a.getAttribute('data-rm'), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  });

  /* every add-to-cart on the page, wherever it lives. Optional
     data-quantity and data-selling-plan (subscriptions) are honoured when
     present; a plain data-variant button keeps its old one-of behaviour. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-variant]');
    if (!b) return;
    e.preventDefault();
    var q = parseInt(b.getAttribute('data-quantity'), 10);
    var item = { id: b.getAttribute('data-variant'), quantity: q > 0 ? q : 1 };
    var sp = b.getAttribute('data-selling-plan');
    if (sp) item.selling_plan = sp;
    addToCart(item);
  });

  refreshCart(false);

  /* ══ THE DAY BAR ══════════════════════════════════════════════════════
     05:00–23:59 across the rule.                                         */
  var H0 = 5, H1 = 24;
  var HOURS = [];
  var dataEl = $('dayBarData');
  if (dataEl) {
    try { HOURS = JSON.parse(dataEl.textContent) || []; } catch (err) { HOURS = []; }
  }

  function fmtH(v) {
    var h = Math.floor(v), m = Math.round((v - h) * 60 / 15) * 15;
    if (m === 60) { h++; m = 0; }
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  }

  var line = $('dbline'), mark = $('dbmark'), hit = $('dbhit');
  var setHour = null;

  if (line && mark && HOURS.length) {
    setHour = function (v) {
      v = Math.max(H0, Math.min(H1 - 0.01, v));
      mark.style.left = ((v - H0) / (H1 - H0) * 100) + '%';
      mark.setAttribute('data-t', fmtH(v));

      var slot = HOURS.filter(function (z) { return v >= z.a && v < z.b; })[0] || HOURS[0];
      var p = slot.main;

      if ($('dbwhen')) $('dbwhen').textContent = slot.when || '';
      if ($('dbclock')) {
        $('dbclock').firstChild.nodeValue = fmtH(v);
        if ($('dbwin')) $('dbwin').textContent = slot.when || '';
      }

      if (p) {
        if ($('dbimg') && p.img) $('dbimg').src = p.img;
        if ($('dbname')) $('dbname').textContent = p.name;
        if ($('dblat')) $('dblat').textContent = slot.lat || '';
        if ($('dbprice')) $('dbprice').textContent = p.price;
        var addBtn = $('dbadd');
        if (addBtn) {
          if (p.available && p.variant) {
            addBtn.setAttribute('data-variant', p.variant);
            addBtn.removeAttribute('disabled');
          } else {
            addBtn.removeAttribute('data-variant');
            addBtn.setAttribute('disabled', 'disabled');
          }
        }
      }

      var altsEl = $('dbalts');
      if (altsEl) {
        altsEl.innerHTML = (slot.alts || []).map(function (a) {
          if (!a) return '';
          var btn = a.available && a.variant
            ? '<button type="button" data-variant="' + a.variant + '">Add</button>'
            : '<a class="arow-view" href="' + (a.url || '#') + '">View</a>';
          return '<div class="arow">' + (a.img ? '<img src="' + a.img + '" alt="">' : '') +
            '<div class="t"><b>' + a.name + '</b><span>' + (a.spec || '') + '</span></div>' +
            '<span class="pr">' + a.price + '</span>' + btn + '</div>';
        }).join('');
      }
    };

    all('.dbzone').forEach(function (z) {
      var a = parseFloat(z.dataset.a), b = parseFloat(z.dataset.b);
      z.style.left = ((a - H0) / (H1 - H0) * 100) + '%';
      z.style.width = ((b - a) / (H1 - H0) * 100) + '%';
    });

    if (hit) {
      var dragging = false;
      var fromEvent = function (e) {
        var r = line.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        return H0 + (Math.max(0, Math.min(r.width, x)) / r.width) * (H1 - H0);
      };
      hit.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { hit.setPointerCapture(e.pointerId); } catch (err) {}
        setHour(fromEvent(e));
      });
      hit.addEventListener('pointermove', function (e) { if (dragging) setHour(fromEvent(e)); });
      hit.addEventListener('pointerup', function () { dragging = false; });
      hit.addEventListener('pointercancel', function () { dragging = false; });
    }

    setHour(6.5);
  }

  /* the-day panel jumps the day bar to that hour */
  all('[data-hour]').forEach(function (a) {
    a.addEventListener('click', function () {
      var v = parseFloat(a.getAttribute('data-hour'));
      setTimeout(function () { if (setHour) setHour(v); }, 320);
    });
  });

  /* The mobile sheet, the mega menu and the mega feature card are driven by
     pdp58c13.js, which layout/theme.liquid loads on every page this file
     loads on. The copies that used to live here bound the same elements a
     second time: two click handlers on the mega trigger cancelled each other,
     and a close-on-any-link handler hid the sheet under the finger on iOS
     before the tap completed. Removed 6 Sep — one controller, in one file. */

  /* ── RAIL ARROWS: one card per press ──────────────────────────────── */
  all('[data-rail]').forEach(function (b) {
    b.onclick = function () {
      var rail = $(b.getAttribute('data-rail'));
      if (!rail) return;
      var card = rail.querySelector('.pcard:not([hidden])');
      var step = card ? card.getBoundingClientRect().width + 12 : 300;
      rail.scrollBy({ left: step * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
    };
  });

  /* ── FORMAT SWITCHER retunes BOTH rails ───────────────────────────── */
  all('#fswitch button').forEach(function (b) {
    b.onclick = function () {
      var f = b.getAttribute('data-f');
      all('#fswitch button').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      all('.rail .pcard').forEach(function (c) {
        c.hidden = !(f === 'all' || c.getAttribute('data-fmt') === f);
      });
      all('.rail').forEach(function (r) { r.scrollTo({ left: 0, behavior: 'smooth' }); });
    };
  });

  /* ══ THE DAY STACK: three slots, one pick each ════════════════════════
     The discount is a setting and defaults to nothing. It may only be
     turned on when a matching automatic discount exists in Shopify —
     otherwise this panel would quote a total checkout will not honour.  */
  var stgrid = document.querySelector('.stgrid');
  if (stgrid) {
    var DISCOUNT = parseFloat(stgrid.getAttribute('data-discount') || '0') / 100;
    var slots = all('.slot', stgrid);
    var slotCount = slots.length;
    var day = {};

    function stRender() {
      var chosen = [];
      slots.forEach(function (s) {
        var k = s.getAttribute('data-slot');
        if (day[k]) chosen.push(day[k]);
      });

      var gross = chosen.reduce(function (t, c) { return t + c.price; }, 0);
      var full = slotCount > 0 && chosen.length === slotCount;
      var net = full ? gross * (1 - DISCOUNT) : gross;

      if ($('stlist')) {
        $('stlist').innerHTML = chosen.length
          ? chosen.map(function (c) {
              return '<li><span>' + c.name + '</span><span>' + formatMoney(c.price) + '</span></li>';
            }).join('')
          : '<li class="empty">Pick one for each hour.</li>';
      }
      if ($('sttot')) $('sttot').textContent = chosen.length ? formatMoney(net) : formatMoney(0);
      if ($('stsave')) {
        var left = slotCount - chosen.length;
        $('stsave').textContent = full
          ? (DISCOUNT > 0
              ? 'You save ' + formatMoney(gross - net) + ' a month · free UK delivery'
              : 'Free UK delivery')
          : (chosen.length ? left + ' slot' + (left > 1 ? 's' : '') + ' to go' : '');
      }
    }

    slots.forEach(function (slot) {
      var key = slot.getAttribute('data-slot');
      all('.opt', slot).forEach(function (o) {
        o.onclick = function () {
          var id = o.getAttribute('data-p');
          var already = day[key] && day[key].id === id;
          all('.opt', slot).forEach(function (x) { x.classList.remove('on'); });
          if (already) {
            day[key] = null;
          } else {
            day[key] = {
              id: id,
              name: o.getAttribute('data-name'),
              price: parseInt(o.getAttribute('data-price'), 10) || 0
            };
            o.classList.add('on');
          }
          stRender();
        };
      });
    });

    if ($('stadd')) {
      $('stadd').onclick = function () {
        var picks = [];
        slots.forEach(function (s) {
          var k = s.getAttribute('data-slot');
          if (day[k]) picks.push({ id: day[k].id, quantity: 1 });
        });
        if (!picks.length) {
          var first = stgrid.querySelector('.slot .opt');
          if (first) first.click();
          return;
        }
        addToCart(picks);
      };
    }

    stRender();
  }

  /* ── FAQ accordion, one open at a time ────────────────────────────── */
  all('.ob button').forEach(function (b) {
    b.onclick = function () {
      var ob = b.parentNode, isOpen = ob.classList.contains('on');
      all('.ob').forEach(function (x) { x.classList.remove('on'); });
      if (!isOpen) ob.classList.add('on');
    };
  });

  /* ── THE DAY CLOCK: the page is a day, so scrolling is time ───────── */
  var dc = $('dayclock');
  if (dc) {
    var H_START = 6, H_END = 22.5;
    var dcUpdate = function () {
      var max = document.documentElement.scrollHeight - innerHeight;
      var f = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
      var v = H_START + f * (H_END - H_START);
      if ($('dcTime')) $('dcTime').textContent = fmtH(v);
      if ($('dcWin')) {
        $('dcWin').textContent = v < 11 ? 'morning' : v < 17 ? 'midday' : v < 20.5 ? 'second wind' : 'evening';
      }
      if ($('dcDot')) $('dcDot').style.left = (f * 49) + 'px';
      dc.classList.toggle('on', scrollY > 420);
    };
    addEventListener('scroll', dcUpdate, { passive: true });
    addEventListener('resize', dcUpdate);
    dcUpdate();
  }

  /* ── the fold reading counts up once, like an instrument powering on ─ */
  var read = document.querySelector('.banner-read');
  if (read && 'IntersectionObserver' in window) {
    var done = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true;
        all('.num', read).forEach(function (el) {
          var txt = el.textContent.trim();
          if (!/^[0-9,]+$/.test(txt)) return;            /* leave 10:1 alone */
          var target = parseInt(txt.replace(/,/g, ''), 10), t0 = null, D = 900;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / D);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased).toLocaleString('en-GB');
            if (p < 1) requestAnimationFrame(step);
          }
          el.textContent = '0';
          requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.4 });
    io.observe(read);
  }

  /* ── the lot request: an honest mailto, no fake lookup ────────────── */
  var coaForm = $('coaForm');
  if (coaForm) {
    coaForm.onsubmit = function () {
      var lot = (($('coaLot') || {}).value || '').trim();
      var msg = $('coaMsg');
      if (!lot) {
        if ($('coaLot')) $('coaLot').focus();
        if (msg) msg.textContent = 'Type the lot number first';
        return false;
      }
      var email = (msg && msg.getAttribute('data-email')) || '';
      if (msg) msg.textContent = 'Opening your email…';
      location.href = 'mailto:' + email +
        '?subject=' + encodeURIComponent('Certificate request — lot ' + lot) +
        '&body=' + encodeURIComponent('Please send the certificate of analysis for lot ' + lot + '.');
      return false;
    };
  }

  /* ── merch marquee: duplicate the track so the loop is seamless ───── */
  var mt = $('mtrack');
  if (mt && mt.children.length) mt.innerHTML = mt.innerHTML + mt.innerHTML;
})();
